import RecorderComponent from "./Recorder";
import EditorComponent from "./Editor";
import PlayerComponent from "./Player";
import VideoSettingsComponent from "./VideoSettings";
export var Recorder = RecorderComponent;
export var Editor = EditorComponent;
export var Player = PlayerComponent;
export var VideoSettings = VideoSettingsComponent;